if (!customElements.get("pay-in-four")) {
  customElements.define(
    "pay-in-four",
    class PayInFour extends HTMLElement {
      static observedAttributes = ["price"];
      constructor() {
        super();
        this.under_template = this.querySelector("#under");
        this.over_template = this.querySelector("#over");

        this.money_format = this.getAttribute("format");
        this.container = this.querySelector(".pay-in-four__container");
      }
      attributeChangedCallback(name, oldValue, newValue) {
        //price attb changes on variant, therefore need to hanle dividing pruce by installments

        if (newValue === oldValue) return; //doesnt need to run if same
        if (!this.container) return;
        var full_price = Number(newValue); //full price, need to convert to installment

        var installment = full_price / 4;

        var installment_money = (installment / 100).toFixed(2);

        // Select the appropriate template based on price
        var template =
          full_price < 10000 ? this.under_template : this.over_template;

        // Clone the template content
        var content = template.content.cloneNode(true);

        // Find the price element in the cloned content
        var price_el = content.querySelector(".inst-price");

        // Update the price in the cloned content
        if (price_el) {
          price_el.innerHTML = this.money_format.replace(
            "{{amount}}",
            installment_money,
          );
        }

        // Clear existing content and append the new template
        this.container.innerHTML = "";
        this.container.appendChild(content);
      }
    },
  );
}
